import ElevationParser from './ol-elevation-parser';
import * as utils from './ol-elevation-parser';

Object.assign(ElevationParser, utils);
export default ElevationParser;
